import { HLS_KR, SS } from '../../utils/playerConstants';
import storage from '../../components/DeviceStorage/DeviceStorage';

let deviceInfo =
  window.AndroidPlayerInterface && window.AndroidPlayerInterface.getDeviceInformation
    ? window.AndroidPlayerInterface.getDeviceInformation()
    : '{}';
deviceInfo = JSON.parse(deviceInfo);

const multipleaudio = {};
// HLS_KR
multipleaudio.hls_kr = {};
multipleaudio.hls_kr.vod = false;
multipleaudio.hls_kr.live = false;
multipleaudio.hls_kr.timeshift = false;
// HLS
multipleaudio.hls = {};
multipleaudio.hls.vod = false;
multipleaudio.hls.live = false;
multipleaudio.hls.timeshift = false;
// SS
multipleaudio.smooth_streaming = {};
multipleaudio.smooth_streaming.vod = true;
multipleaudio.smooth_streaming.live = false;
multipleaudio.smooth_streaming.timeshift = false;

// Put only SINGLE streams here
const supported_stream_types = {};
// in priority order, first has a major priority
supported_stream_types.vod = [SS];
supported_stream_types.live = [HLS_KR];
supported_stream_types.timeshift = [HLS_KR];

export default {
  appKey: storage.getItem('force_appkey')
    ? 'b530d0a15a344685ae6b578a9f864688'
    : 'b49172040b11ddbf0b37db296a851e35',
  appSubkey: 'zxv10',
  // Request params
  device_category: 'stb',
  device_id: deviceInfo.device_id, // como obtener device id
  device_manufacturer: 'ZTE',
  device_model: 'zxv10',
  device_name: deviceInfo.device_name || 'zxv10', // como arman device Name
  device_so: deviceInfo.device_so || 'Android 9', // como obtener device_so
  device_type: storage.getItem('force_appkey') ? 'ptv' : 'ott',
  stream_type: 'smooth_streaming',
  appversion: deviceInfo.appversion || '509', // como obtener appversion
  firmwareversion: deviceInfo.firmwareversion || '001.999.999', // como obtener firmware version,
  useEpgPostals: true,
  akamai_id: 'Coship',
  nodetv: 'nagratv',
  hideArrowHeader: true,
  serial_id: deviceInfo.device_id || 'FF05E537L06',
  // akamai_mfwk: 'mfwkcoship-api.clarovideo.net'
  akamai_mfwk: (window.location && window.location.protocol) ? window.location.protocol + '//' + 'mfwkstbzte-api.clarovideo.net' : 'http://mfwkstbzte-api.clarovideo.net'
  // multipleaudio: multipleaudio, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // supported_stream_types: supported_stream_types, //Estos valores ahora se toman de la llave supported_stream de METADATA
  // serial_id: '2153017310HYGA500033'
  // init: init,
};



// WEBPACK FOOTER //
// ./src/devices/zte/config.js